import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap5';
import { useFinchConnect } from 'react-finch-connect';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import StepTab from 'components/new_ui/Tabs/StepTab';
import useFinchStatus from 'components/Common/Members/Hooks/useFinchStatus';
import { useContext } from 'components/Managers/Members/Context';

export default function Index() {
  const { loading: loadingFinchStatus, status: finchStatus } = useFinchStatus();
  const { state: { finchOptions }, actions } = useContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSuccess = ({ code }) => {
    setLoading(true);

    actions.finchConnect(
      code,
      () => {
        setLoading(false);
        navigate(routes.managers.members.hrSystem.import);
      },
    );
  };

  const onError = () => setLoading(false);

  const { open } = useFinchConnect({
    clientId: finchOptions.clientId,
    products: ['company', 'directory', 'individual'],
    sandbox: finchOptions.sandbox,
    manual: true,
    onSuccess,
    onError,
  });

  return (
    <>
      <StepTab total={3} current={2} />

      <div className="content">
        <section>
          <h1 className="mb-3">Connect to my HR System</h1>

          <p>
            LeggUP uses Finch to connect your HR System. The connection is 100% secure, and private.
          </p>

          <p>
            After connecting to your system, you will have the ability to import
            your full directory or selected employees.
          </p>

          {!loadingFinchStatus && finchStatus.status === 'connected' && (
            <p className="fw-semibold">
              There is already an active connection to Finch. You can import employees by clicking
              {' '}
              <Link
                to={routes.managers.members.hrSystem.import}
              >
                this link
              </Link>
              .
            </p>
          )}
        </section>

        <footer>
          <Link
            to={routes.managers.members.index}
            className="btn btn-outline-primary"
          >
            Cancel
          </Link>

          <Button
            disabled={loading}
            onClick={open}
          >
            {loading && <LoadingPlaceholder placement="inline" text=" " />}
            Connect to HRIS
          </Button>
        </footer>
      </div>
    </>
  );
}
